const YOUTUBE_HOSTS = ['www.youtube.com', 'youtube.com', 'm.youtube.com'];

const VIDEO_ID_PATTERN = /^[\w-]{11}$/;

const extractVideoID = (url: URL): string | undefined => {
  if (url.hostname === 'youtu.be') {
    const videoID = url.pathname.slice(1);
    return VIDEO_ID_PATTERN.test(videoID) ? videoID : undefined;
  }

  if (!YOUTUBE_HOSTS.includes(url.hostname)) {
    return undefined;
  }

  if (url.pathname === '/watch') {
    const videoID = url.searchParams.get('v') ?? '';
    return VIDEO_ID_PATTERN.test(videoID) ? videoID : undefined;
  }

  const pathMatch = url.pathname.match(
    /^\/(?:shorts|embed|live)\/([\w-]{11})$/,
  );
  return pathMatch?.[1];
};

// "3s" "1m30s" "1h2m3s" "90" のような t パラメータを秒数に変換する
const parseStartSeconds = (t: string | null): number => {
  if (!t) {
    return 0;
  }
  if (/^\d+$/.test(t)) {
    return Number(t);
  }
  const match = t.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
  if (!match || match[0] === '') {
    return 0;
  }
  const [, hours = '0', minutes = '0', seconds = '0'] = match;
  return Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
};

/**
 * YouTube の動画 URL から自動生成サムネイル画像の URL を返す。
 * YouTube の動画 URL でない場合は undefined を返す。
 */
export const getYouTubeThumbnailURL = (linkURL: string): string | undefined => {
  let url: URL;
  try {
    url = new URL(linkURL);
  } catch {
    return undefined;
  }

  const videoID = extractVideoID(url);
  if (!videoID) {
    return undefined;
  }
  return `https://i.ytimg.com/vi/${videoID}/hqdefault.jpg`;
};

/**
 * YouTube の動画 URL を埋め込みプレイヤー用 URL に変換する。
 * YouTube の動画 URL でない場合は undefined を返す。
 */
export const getYouTubeEmbedURL = (linkURL: string): string | undefined => {
  let url: URL;
  try {
    url = new URL(linkURL);
  } catch {
    return undefined;
  }

  const videoID = extractVideoID(url);
  if (!videoID) {
    return undefined;
  }

  const embedURL = new URL(`https://www.youtube.com/embed/${videoID}`);
  embedURL.searchParams.set('rel', '0');
  const start = parseStartSeconds(url.searchParams.get('t'));
  if (start > 0) {
    embedURL.searchParams.set('start', String(start));
  }
  return embedURL.toString();
};
